export const BNK_STMT_comingBackFromPerfiosReducer = {
  BNK_STMT_comingBackFromPerfios: (state, action) => {
    state.comingBackFromPerfiosFlag = action.payload;
  },
};
